<template>
	<section>
		<div v-if="showParentView('page-template')">
			<header-page
				name="template"
				:title="$route.meta.title"
			/>
			<template-list
				:columns="columns"
				:current-page="currentPage"
				:rows="table.rows"
				:last-page="table.lastPage"
				:codeProject="codeProject"
				:project-id="projectId"
				@on-page="changePage"
				@on-search="onSearch"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			/>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
import templateList from '@/components/template/template-list';
import quickActions from '@/components/shared/quick-actions';

function created() {
	if (this.$route.name !== 'page-resources-assignment') {
		this.loadData(`project/${this.codeProject}/template`);
	}
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData(`project/${this.codeProject}/template`);
}

function openModal() {
	this.goTo('page-template-clone', { params: { codeProject: this.codeProject, projectId: this.projectId } });
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CC',
				text: 'Crear Template',
				img: 'https://goo.su/BL0U',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Nombre', checked: true, visible: true },
			{ id: 2, name: 'Descripcion', checked: true, visible: true },
			{ id: 3, name: 'Acciones', checked: true, visible: true },
		],
		currentPage: 1,
	};
}

export default {
	name: 'page-template',
	data,
	created,
	components: {
		templateList,
		quickActions,
	},
	methods: {
		changePage,
		openModal,
		onSearch(value) {
			this.params.search = value;
			this.loadData(`project/${this.codeProject}/template`);
		},
	},
	props: {
		codeProject: {
			type: String,
		},
		projectId: {
			type: [Number, String],
		},
		codeTemplate: {
			type: [Number, String],
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-template') {
					this.loadData(`project/${this.codeProject}/template`);
				}
			}
		},
	},
};
</script>




// WEBPACK FOOTER //
// src/pages/template/page-template.vue